export default "__VITE_ASSET__a36dca59__"